/*
 * -----------------------------------------------------------------------
 *  <copyright file="import-file.ts" company="Triumph Research Intelligence">
 *      Copyright (C) 2023 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import * as Papa from 'papaparse';
import readXlsxFile from 'read-excel-file/browser';

export default ({ file, lovs, isSystemLevel, studyId, importer }: any) =>
    new Promise((resolve, reject) => {
        if (file.size > 50000) {
            reject(new Error('50k max file size exceeded!'));
            return;
        }
        const filename = file.name.toUpperCase();
        if (filename.indexOf('.CSV') >= 0) {
            const delimiter = ',';
            Papa.parse(file, {
                delimiter,
                complete: (results: any) => {
                    if (results.errors.length) reject(results.errors);
                    else
                        resolve(
                            isSystemLevel === undefined
                                ? importer(results.data, lovs, studyId)
                                : importer(results.data, lovs, isSystemLevel),
                        );
                },
            });
        } else if (filename.indexOf('.PSV') >= 0) {
            const delimiter = '|';
            Papa.parse(file, {
                delimiter,
                complete: (results: any) => {
                    if (results.errors.length) reject(results.errors);
                    else
                        resolve(
                            isSystemLevel === undefined
                                ? importer(results.data, lovs, studyId)
                                : importer(results.data, lovs, isSystemLevel),
                        );
                },
            });
        } else if (filename.indexOf('.XLSX') >= 0)
            readXlsxFile(file, { dateFormat: 'YYYY-MM-DD' })
                .then((rows: any) =>
                    isSystemLevel === undefined
                        ? resolve(importer(rows, lovs, studyId))
                        : resolve(importer(rows, lovs, isSystemLevel)),
                )
                .catch((error) => console.error(error));
        else reject(new Error('File type not supported.'));
    });
